import React from "react";

const DepartmentList = ({ items, onEdit }) => {
	const list = items || [];
	return (
		<div className="inbox-body">
			<div className="inbox-body no-pad table-responsive">
				<table className="table table-inbox table-hover table-bordered">
					<thead>
						<tr>
							<th className="text-center">sn</th>
							<th>Name</th>
							<th>Date Created</th>
							<th className="text-center">Edit </th>
						</tr>
					</thead>
					<tbody>
						{list.map((item, index) => (
							<tr key={index}>
								<td className="inbox-small-cells text-center">
									{index + 1}
								</td>
								<td className="view-message">
									<h5>{item.name}</h5>
								</td>

								<td className="view-message">
									<strong title="Date created">
										{new Date(
											parseInt(item.created_at)
										).toLocaleDateString()}
									</strong>
								</td>

								<td className="view-message text-center">
									<button
										title="Update"
										onClick={() => onEdit(item)}
										className="mdl-button mdl-button--icon mdl-button--colored btn-default"
									>
										<i className="material-icons text-success">
											edit
										</i>
									</button>
								</td>
							</tr>
						))}
					</tbody>
				</table>
				{list.length < 1 && (
					<div className="text-center m-t-10 m-b-20">
						<h5 className="text-danger">
							No Department is added yet!
						</h5>
					</div>
				)}
			</div>
		</div>
	);
};

export default DepartmentList;
